import React from 'react'
import styled from 'styled-components'
import { Flex } from 'ui/acro'
import { LocationIcon } from './EventDetailView.style'
import { community_event_date_filtered_event } from 'gtm/pushEvents'
import { regionFilterLabel } from './countryFilter'

const Container = styled(Flex)`
  align-items: center;
  gap: 24px;
  margin: 24px 0;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`
const Locationsection = styled(Flex)`
  border-radius: 8px;
  font-family: 'Proxima-Nova';
  background: #f2f2f2;
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
`

const LocationIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
`

const LocationLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.308px;
  color: #3b3b3b;
`
const Filters = styled(Flex)`
  align-items: center;
  gap: 12px;
  @media (max-width: 768px) {
    /* gap: 6px;
    flex-wrap: wrap; */
    gap: 8px;
    max-width: 100%;
    overflow-x: auto;
    padding: 12px 0;
  }
`
const FilterItem = styled('div')`
  border: 1px solid #a3a3a3;
  border-radius: 360px;
  padding: 12px 16px;
  background-color: ${({ active }) => (active ? '#000' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#000')};
  cursor: pointer;
  font-weight: 500;
  line-height: 18px;
  font-size: 14px;
  letter-spacing: 0.7px;
  white-space: nowrap;
  font-family: 'Proxima-Nova';
  text-transform: uppercase;
  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`
const filterMap = {
  upcoming: 'Upcoming Events',
  this_week: 'This Week'
}

const EventFilters = ({
  selectedFilter,
  setSelectedFilter,
  setLocation,
  selectedRegion
}) => {
  const locationClickHandler = () => {
    setLocation(true)
  }

  const locationLabel = selectedRegion?.region
    ? regionFilterLabel(selectedRegion)
    : 'State'

  return (
    <Container>
      <Locationsection onClick={locationClickHandler}>
        {locationLabel !== 'State' && (
          <LocationIconWrap aria-hidden>
            <LocationIcon />
          </LocationIconWrap>
        )}
        <LocationLabel>{locationLabel}</LocationLabel>
      </Locationsection>
      <Filters>
        {Object.keys(filterMap).map((key) => (
          <FilterItem
            active={selectedFilter === key}
            key={key}
            onClick={() => {
              setSelectedFilter(key)
              community_event_date_filtered_event(key)
            }}
          >
            {filterMap[key]}
          </FilterItem>
        ))}
      </Filters>
    </Container>
  )
}

export default EventFilters
